<template>
  <div class="col-12 p-4 text-center align-items-center no-info mt-4">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-1 align-self-center">
        <em class="far fa-folder-open icon no-info-icon pl-2"/>
      </div>
      <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
        <span class="no-info-text">No hay información disponible.</span>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
  .no-info-text {
    text-align: left;
    font: Bold 16px/22px Lato;
    letter-spacing: 0;
    color: #727272;
    opacity: 1;
  }
  .no-info-icon {
    color: #727272;
    font-size: 32px;
  }
}
</style>

<script>
export default {}
</script>